import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"grid-list-xl":""}},[_c(VCard,{attrs:{"dark":""}},[_c(VImg,{staticClass:"grey lighten-2",attrs:{"height":"400","width":"100%","src":require('@/assets/home/home-charger-web.jpg')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }